import styled, { css } from 'styled-components'

const WebContainer = styled.div`
    ${({ theme }) => {
        return css`
            display: flex;
            flex-direction: column;
            margin-top: 150px;
            min-height: 80vh;
        `;
    }}
`; 

const BoardInfoContainer = styled.div`
    ${({ theme }) => {
        const { device } = theme;
        return css`
        background: #FBFBFB;
        // width: 100vw;
        // height: 1135px;
        padding: 30px 20px;
        @media ${device.tabletM} {
            padding: 30px 60px 30px 100px;
            min-height: 80vh;
            display: flex;
            flex-direction: row;
        }
        `;
    }}
`;

const BoardVisualizeContainer = styled.div`
    ${({ theme }) => {
        return css`
            font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
            font-weight:400;
            font-size: 16px;
            line-height: 3rem;
            width: 100%;
            background: white;
            border: 1px solid #EEEEEE;
            box-sizing: border-box;
            border-radius: 5px;
            padding: 15px 45px;
            margin-bottom: 45px;
            @media (min-width: 610px) {
                padding: 45px;
                min-height: 70vh;
            }
            @media (min-width: 806px) {
                margin-bottom: 0px;
            }
            @media (min-width: 976px) {
                min-height: 339px;
            }
            @media (min-width: 1426px) {
                max-height: 80vh;
                min-height: 70vh;
                margin-bottom: 0px;
            }
        `;
    }}
`;

const InfoTitle = styled.div`
    ${({ theme }) => {
        const { colors, device } = theme;
        return css`
        font-family: Noto Sans KR;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        color: ${colors.blue_3};
        margin-bottom: 15px;
        @media ${device.tabletM} {
            margin-bottom: 0px;
            font-size: 16px;
            line-height: 18px;
            min-width: 94px;
        }
        `;
    }}
`;

const SelectRowContainer = styled.div`
    ${({ theme }) => {
        return css`
        display: flex;
        justify-content: flex-start;
        align-items: center;
        // padding-top: 15px;
        `;
    }}
`;

const SelectYearContainer = styled.div`
    ${({ theme }) => {
        const { device, colors } = theme;
        return css`
        box-sizing: border-box;
        position: relative;
        border-radius: 4px;
        background-size: 20px;
        cursor: pointer;
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        margin-top: 0px;
        padding-top: 0px;
        color: ${colors.blue_3};
        width: 100%;
        border: 1px solid #EEEEEE;
        & div {
            border: none;
        }
        @media ${device.tabletM} {
            // width: 87px;
            width: 102px;
            height: 42px;
        }
        `;
    }}
`;



const Row = styled.div`
    ${({ theme }) => {
        const { device } = theme;
        return css`
        margin-bottom: 10px;
        @media ${device.tabletM} {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
        }
        `;
    }}
`;

const styledComponents = { WebContainer, BoardInfoContainer, BoardVisualizeContainer, Row, InfoTitle, SelectRowContainer, SelectYearContainer };

export default styledComponents;